module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    on: {
      "click:outside": function($event) {
        return _vm.$emit('close')
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline grey darken-3 d-flex justify-space-between"
  }, [_c('span', {
    staticClass: "text-h6"
  }, [_vm._v("Post Comments (" + _vm._s(_vm.comments.length) + ")")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [(_vm.comments && _vm.comments.length > 0) ? _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": "",
      "height": "450px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Commenter")]), _vm._v(" "), _c('th', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px"
          }
        }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Comment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.comments), function(comment, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [(comment.comment_user_url) ? _c('a', {
            attrs: {
              "href": comment.comment_user_url,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(comment.comment_user))]) : _c('span', [_vm._v("@" + _vm._s(comment.comment_user))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateFormat")(comment.comment_date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comment.comment))])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3263868770)
  }) : _c('div', {
    staticClass: "text-center pa-5"
  }, [_vm._v("\n        No comments found for this post.\n      ")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26710522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReportInternal/ViewPostCommentsModal.vue
// module id = 2045
// module chunks = 0